import { FC, HTMLAttributes } from 'react';

import { Flex, Typography } from 'antd';

import { ChannelAvatar } from 'entities/Channel';

interface IOptionWithAvatarProps extends HTMLAttributes<HTMLDivElement> {
	name: string;
	logo: string | null;
	subText?: string | number;
}

export const OptionWithAvatar: FC<IOptionWithAvatarProps> = ({ name, logo, subText, ...props }) => {
	return (
		<Flex gap={8} align="center" {...props}>
			<ChannelAvatar name={name} logo={logo} size={32} style={{ flexShrink: 0 }} />
			<Typography.Text ellipsis>{name}</Typography.Text>
			{!!subText && (
				<Typography.Text type="secondary" style={{ marginLeft: 'auto' }}>
					{subText.toLocaleString()}
				</Typography.Text>
			)}
		</Flex>
	);
};
